import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function LedgerMaster(props) {
  const [ledgerEntries, setLedgerEntries] = useState([]);
  const [AcCode, setAcCode] = useState('');
  const [AcGroupCode, setAcGroupCode] = useState('');
  const [AcGroupName, setAcGroupName] = useState('');
  const [AcHead, setAcHead] = useState('');
  const [AcHeadEng, setAcHeadEng] = useState('');
  const [DetailYN, setDetailYN] = useState('');
  const [Address1, setAddress1] = useState('');
  const [Address2, setAddress2] = useState('');
  const [City, setCity] = useState('');
  const [MobileNo, setMobileNo] = useState('');
  const [Email, setEmail] = useState('');
  const [AadharCardNo, setAadharCardNo] = useState('');
  const [PanNo, setPanNo] = useState('');
  const [GSTNo, setGSTNo] = useState('');
  const [Remark1, setRemark1] = useState('');
  const [Remark2, setRemark2] = useState('');
  const [Remark3, setRemark3] = useState('');
  const [Remark4, setRemark4] = useState('');
  const [Remark5, setRemark5] = useState('');
  const [UserID, setUserID] = useState('');
  const [formMode, setFormMode] = useState('add');
  const [editLedgerId, setEditLedgerId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [acGroups, setAcGroups] = useState([]);
  const [SubLedger, setSubLedger] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [currentItems, setCurrentItems] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    if (ledgerEntries.length > 0) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const newCurrentItems = ledgerEntries.slice(indexOfFirstItem, indexOfLastItem);
      setCurrentItems(newCurrentItems);
    }
    else {
      setCurrentItems([]);
    }
  }, [ledgerEntries, currentPage, itemsPerPage]);

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };


  useEffect(() => {
    fetchLedgerMaster();
    fetchAcGroups();
    fetchSubLedger();
  }, []);

  const fetchLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/ledger-master');
      setLedgerEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setAcCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.AcCode > maxEntryNo) {
        maxEntryNo = entry.AcCode;
      }
    }
    return maxEntryNo;
  };

  const fetchAcGroups = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/acgroups');
      setAcGroups(response.data);
      //console.log('AcGroups:', response.data);
    } catch (error) {
      console.log('Error fetching AcGroups:', error);
    }
  };

  const fetchSubLedger = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgergroups');
      setSubLedger(response.data);
      //console.log('SubLedger:', response.data);
    } catch (error) {
      console.log('Error fetching AcGroups:', error);
    }
  };

  const addLedger = async () => {
    
    try {
      await axios.post('https://www.wingap.net.in/api/ledger-master', {
        AcCode: AcCode,
        AcGroupCode: AcGroupCode,
        AcHead: AcHead,
        AcHeadEng: AcHeadEng,
        DetailYN: DetailYN,
        Address1: Address1,
        Address2: Address2,
        City: City,
        MobileNo: MobileNo,
        Email: Email,
        AadharCardNo: AadharCardNo,
        PanNo: PanNo,
        GSTNo: GSTNo,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        Remark4: Remark4,
        Remark5: Remark5,
        USERID: props.name
      });
      fetchLedgerMaster();
      // Clear the form inputs here
      clearFormInputs();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateLedger = async (AcCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/ledger-master/${AcCode}`, {
        AcCode: AcCode,
        AcGroupCode: AcGroupCode,
        AcHead: AcHead,
        AcHeadEng: AcHeadEng,
        DetailYN: DetailYN,
        Address1: Address1,
        Address2: Address2,
        City: City,
        MobileNo: MobileNo,
        Email: Email,
        AadharCardNo: AadharCardNo,
        PanNo: PanNo,
        GSTNo: GSTNo,
        Remark1: Remark1,
        Remark2: Remark2,
        Remark3: Remark3,
        Remark4: Remark4,
        Remark5: Remark5,
        USERID: props.name
      });
      fetchLedgerMaster();
      // Clear the form inputs here
      clearFormInputs();
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteLedger(deleteEntryNo.AcCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteLedger = async (AcCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/ledger-master/${AcCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchLedgerMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (ledger) => {
    setFormMode('edit');
    setAcCode(ledger.AcCode);
    setAcGroupCode(ledger.AcGroupCode);
    const selectedGroup = acGroups.find(group => group.AcGroupCode === ledger.AcGroupCode);
    if (selectedGroup) {
      setAcGroupName(selectedGroup.AcGroupName);
    }
    const selectedGroup1 = SubLedger.find(group => group.SubLedgerGroupCode === ledger.SubLedgerGroupCode);
    setAcHead(ledger.AcHead);
    setAcHeadEng(ledger.AcHeadEng);
    setDetailYN(ledger.DetailYN);
    setAddress1(ledger.Address1);
    setAddress2(ledger.Address2);
    setCity(ledger.City);
    setMobileNo(ledger.MobileNo);
    setAadharCardNo(ledger.AadharCardNo);
    setPanNo(ledger.PanNo);
    setGSTNo(ledger.GSTNo);
    setRemark1(ledger.Remark1);
    setRemark2(ledger.Remark2);
    setRemark3(ledger.Remark3);
    setRemark4(ledger.Remark4);
    setRemark5(ledger.Remark5);
    setUserID(ledger.UserID);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = ledgerEntries.filter((ledger) => {
      const AcCode = ledger.AcCode.toString().toLowerCase();
      const AcGroupCode = ledger.AcGroupCode.toString().toLowerCase();
      const AcHead = ledger.AcHead.toString().toLowerCase();
      const AcHeadEng = ledger.AcHeadEng.toString().toLowerCase();
      const DetailYN = ledger.DetailYN.toString().toLowerCase();
      const Address1 = ledger.Address1.toString().toLowerCase();
      const Address2 = ledger.Address2.toString().toLowerCase();
      const City = ledger.City.toString().toLowerCase();
      const MobileNo = ledger.MobileNo.toString().toLowerCase();
      const Email = ledger.Email.toString().toLowerCase();
      const AadharCardNo = ledger.AadharCardNo.toString().toLowerCase();
      const PanNo = ledger.PanNo.toString().toLowerCase();
      const GSTNo = ledger.GSTNo.toString().toLowerCase();
      const Remark1 = ledger.Remark1.toString().toLowerCase();
      const Remark2 = ledger.Remark2.toString().toLowerCase();
      const Remark3 = ledger.Remark3.toString().toLowerCase();
      const Remark4 = ledger.Remark4.toString().toLowerCase();
      const Remark5 = ledger.Remark5.toString().toLowerCase();
      const UserID = ledger.UserID.toString().toLowerCase();

      return (
        AcCode.includes(searchQuery.toLowerCase()) ||
        AcGroupCode.includes(searchQuery.toLowerCase()) ||
        AcHead.includes(searchQuery.toLowerCase()) ||
        AcHeadEng.includes(searchQuery.toLowerCase()) ||
        DetailYN.includes(searchQuery.toLowerCase()) ||
        Address1.includes(searchQuery.toLowerCase()) ||
        Address2.includes(searchQuery.toLowerCase()) ||
        City.includes(searchQuery.toLowerCase()) ||
        MobileNo.includes(searchQuery.toLowerCase()) ||
        Email.includes(searchQuery.toLowerCase()) ||
        AadharCardNo.includes(searchQuery.toLowerCase()) ||
        PanNo.includes(searchQuery.toLowerCase()) ||
        GSTNo.includes(searchQuery.toLowerCase()) ||
        Remark1.includes(searchQuery.toLowerCase()) ||
        Remark2.includes(searchQuery.toLowerCase()) ||
        Remark3.includes(searchQuery.toLowerCase()) ||
        Remark4.includes(searchQuery.toLowerCase()) ||
        Remark5.includes(searchQuery.toLowerCase()) ||
        UserID.includes(searchQuery.toLowerCase())
      );
    });

    setLedgerEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    // Clear form inputs here
    clearFormInputs();
    handleCancel();
    fetchLedgerMaster();
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditLedgerId('');
    // Clear form inputs here
    clearFormInputs();
  };

  const clearFormInputs = () => {
    setAcGroupCode('');
    setAcHead('');
    setAcHeadEng('');
    setDetailYN('');
    setAddress1('');
    setAddress2('');
    setCity('');
    setMobileNo('');
    setEmail('');
    setAadharCardNo('');
    setPanNo('');
    setGSTNo('');
    setRemark1('');
    setRemark2('');
    setRemark3('');
    setRemark4('');
    setRemark5('');
    setUserID('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "LedgerData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>LedgerMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && (
        <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
          >
            Download PDF
          </Button>
        </Grid>
      )}
      {!showGrid && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>

            {/* AcCode */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="AcCode" style={{ width: '150px', marginRight: '10px' }}>AcCode</label>
              <input
                type="text"
                value={AcCode}
                readOnly
                placeholder="AcCode"
                style={{ padding: '5px', width: '10%' }}
              />
            </div>

            {/* AcGroupCode */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="AcGroupCode" style={{ width: '150px', marginRight: '10px' }}>AcGroupCode</label>
              <input
                type="text"
                value={AcGroupCode}
                readOnly
                placeholder="AcGroupCode"
                style={{ padding: '5px', width: '10%' }}
              />
            </div>

            {/* AcGroupName */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="AcGroupName" style={{ width: '150px', marginRight: '10px' }}>AcGroupName</label>
              <select
                value={AcGroupName}
                onChange={(e) => {
                  const selectedGroupName = e.target.value;
                  setAcGroupName(selectedGroupName);

                  // Find the corresponding AcGroupCode for the selected group name
                  const selectedGroup = acGroups.find(group => group.AcGroupName === selectedGroupName);
                  if (selectedGroup) {
                    setAcGroupCode(selectedGroup.AcGroupCode);
                  }
                }}
                style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
              >
                <option value="">Select AcGroupName</option>
                {acGroups.map((group) => (
                  <option key={group.AcGroupCode} value={group.AcGroupName}>
                    {group.AcGroupName}
                  </option>
                ))}
              </select>
            </div>

            {/* AcHead */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="AcHead" style={{ width: '150px', marginRight: '10px' }}>AcHead</label>
              <input
                type="text"
                value={AcHead}
                onChange={(e) => setAcHead(e.target.value)}
                placeholder="AcHead"
                style={{ padding: '5px', width: '60%' }}
              />
            </div>

            {/* AcHeadEng */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="AcHeadEng" style={{ width: '150px', marginRight: '10px' }}>AcHeadEng</label>
              <input
                type="text"
                value={AcHeadEng}
                onChange={(e) => setAcHeadEng(e.target.value)}
                placeholder="AcHeadEng"
                style={{ padding: '5px', width: '60%' }}
              />
            </div>

            {/* DetailYN */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="DetailYN" style={{ width: '150px', marginRight: '10px' }}>DetailYN</label>
              <input
                type="text"
                value={DetailYN}
                onChange={(e) => setDetailYN(e.target.value)}
                placeholder="DetailYN"
                style={{ padding: '5px', width: '10%' }}
              />
            </div>
            {/* Address1 */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="Address1" style={{ width: '150px', marginRight: '10px' }}>Address1</label>
              <input
                type="text"
                value={Address1}
                onChange={(e) => setAddress1(e.target.value)}
                placeholder="Address1"
                style={{ padding: '5px', width: '60%' }}
              />
            </div>
            {/* Address2 */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="Address2" style={{ width: '150px', marginRight: '10px' }}>Address2</label>
              <input
                type="text"
                value={Address2}
                onChange={(e) => setAddress2(e.target.value)}
                placeholder="Address2"
                style={{ padding: '5px', width: '60%' }}
              />
            </div>
            {/* City */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="City" style={{ width: '150px', marginRight: '10px' }}>City</label>
              <input
                type="text"
                value={City}
                onChange={(e) => setCity(e.target.value)}
                placeholder="City"
                style={{ padding: '5px', width: '30%' }}
              />
            </div>
            {/* MobileNo */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="MobileNo" style={{ width: '150px', marginRight: '10px' }}>MobileNo</label>
              <input
                type="text"
                value={MobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
                placeholder="MobileNo"
                style={{ padding: '5px', width: '20%' }}
              />
            </div>
            {/* Email */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="Email" style={{ width: '150px', marginRight: '10px' }}>Email</label>
              <input
                type="text"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                style={{ padding: '5px', width: '20%' }}
              />
            </div>
            {/* AadharCardNo */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="Email" style={{ width: '150px', marginRight: '10px' }}>AadharCardNo</label>
              <input
                type="text"
                value={AadharCardNo}
                onChange={(e) => setAadharCardNo(e.target.value)}
                placeholder="AadharCardNo"
                style={{ padding: '5px', width: '20%' }}
              />
            </div>
            {/* PanNo */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="PanNo" style={{ width: '150px', marginRight: '10px' }}>PanNo</label>
              <input
                type="text"
                value={PanNo}
                onChange={(e) => setPanNo(e.target.value)}
                placeholder="PanNo"
                style={{ padding: '5px', width: '20%' }}
              />
            </div>
            {/* GSTNo */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="GSTNo" style={{ width: '150px', marginRight: '10px' }}>GSTNo</label>
              <input
                type="text"
                value={GSTNo}
                onChange={(e) => setGSTNo(e.target.value)}
                placeholder="GSTNo"
                style={{ padding: '5px', width: '20%' }}
              />
            </div>
            {/* Remark1 */}
            <div style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
              <label htmlFor="Remark1" style={{ width: '150px', marginRight: '10px' }}>Remark1</label>
              <input
                type="text"
                value={Remark1}
                onChange={(e) => setRemark1(e.target.value)}
                placeholder="Remark1"
                style={{ padding: '5px', width: '60%' }}
              />
            </div>

          </div>
          <div>
            <button
              className={formMode === 'add' ? 'add-button' : 'update-button'}
              onClick={formMode === 'add' ? addLedger : () => updateLedger(AcCode)}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '10px',
              }}
            >
              {formMode === 'add' ? 'Add' : 'Update'}
            </button>
            <button
              className="view-button"
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '10px',
                marginBottom: '10px',
              }}
            >
              Cancel
            </button>
          </div>
        </>

      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Code
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Account Head
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Account Head English
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  PrintPosition
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((ledger) => (
                <tr key={ledger.AcCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ledger.AcCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ledger.AcGroupCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ledger.AcHead}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ledger.AcHeadEng}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{ledger.AcPrintPosition}</td>
                  <td className="print-hide">
                    <button
                      className='action-btn btn-edit'
                      onClick={() => setEditForm(ledger)}
                    >
                      Edit
                    </button>
                    <button
                      className='action-btn btn-delete'
                      onClick={() => {
                        setDeleteEntryNo({ AcCode: ledger.AcCode });
                        setOpenConfirmation(true);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Stack spacing={2} style={{ marginTop: '10px', textAlign: 'center', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Pagination
              count={Math.ceil(ledgerEntries.length / itemsPerPage)}
              page={currentPage}
              onChange={handleChangePage}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Stack>


          <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default LedgerMaster;
